import { useNamespace, useProduct } from "~/hooks";

import { Phrase, LMS, FluencyIo } from "../";

function SignIn() {
  const { name } = useProduct();
  const { translate } = useNamespace("outdoor");

  if (name === "Yowza") return <Phrase mt={["0", "4.375rem"]}>Your voice, unlocked.</Phrase>;
  if (name === "LMS") return <LMS />;
  if (name === "fluency-io") return <FluencyIo />;

  return (
    <div className="flex-auto w-full max-w-[440px] flex items-center justify-center">
      <h1 className="font-gt text-[18px] md:text-5xl font-bold leading-6 md:leading-[56px] text-center md:text-left text-basic-white-50 md:whitespace-pre-line">
        {translate("outdoor@signIn-accounts")}
      </h1>
    </div>
  );
}

export default SignIn;
